import * as React from 'react';
import { Props as LayoutProps } from './PaywallSniperLayout';
import { useState } from 'react';
import axios from 'axios';

export type Props = {
	Layout: any;
};

export const PaywallSniperContainer = (props: Props) => {
	const [url, setUrl] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);
	const [input, setInput] = useState(true);
	const [data, setData] = useState(null);
	const handleSnipe = async () => {
		// Ensure we have a url value from state
		if (!url) {
			console.warn('handleSnipe called with empty URL');
			return;
		}
		// Build JSON body from the controlled url state
		const body = { url };
		setLoading(true);
		setInput(false);
		try {
			const path = 'snipe';
			const domain = 'https://sniper.services.faizhirani.com/v1/';
			// const domain = 'http://localhost:6063/v1/';
			const endpoint = domain + path;
			const response = await axios.post(endpoint, body);
			if (response.data.hash) {
				await pollHash(response.data.hash as string);
			} else {
				setData(response.data.article);
				setLoading(false);
			}
		} catch (e) {
			console.log('e is', e);
			setLoading(false);
		}
	};

	const pollHash = async (hash: string) => {
		console.log('hash is', hash);
		const path = 'checkHash';
		// const domain = 'http://localhost:6063/v1/';
		const domain = 'https://sniper.services.faizhirani.com/v1/';
		// hash = 'd7703841cfb520e9e5bfa380a8a9fa1d46e60c8c27f54eec7dded940527ba5d2';
		const params = {
			params: { hash },
		};
		const response = await axios.get(domain + path, params);
		if (!response.data) setTimeout(() => pollHash(hash), 5000);
		else {
			setData(response.data.article);
			setLoading(false);
		}
	};

	const render = () => {
		const Layout = props.Layout;
		const outgoingProps: LayoutProps = {
			loading,
			input,
			data,
			handleSnipe,
			setUrl,
		};
		const returnValue = <Layout {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
